import { SleekNoteMessage } from "src/app/model/interfaces/sleeknote-message";

export const SleeknoteData: SleekNoteMessage[] = [
    /*
    {
        StartDate: new Date("2021-09-22T15:30:00"),
        EndDate: new Date("2021-03-15T00:00:00"),
        Id: "pricechange-001",
        Headline: "Vigtig information om nye priser fra april 2022",
        Text: "Priserne justeres for første gang i 8 år, og vi har samlet et overblik over de nye priser, der gælder fra april 2022.<br> Fx stiger prisen kun 1 kr. på et 1/8-lod. Se og læs mere om de nye priser og den nye gevinstplan her.",
        Cta: 'pricechange-001',
        CtaText: 'Læs mere',
        CtaType: 'event',
        ShowOnlyOnURL: [
            '/betaling/dit-spil'],
        ShowOnlyIfLoggedIn: false,
        Theme: "info"
    }
    

    {
        StartDate: new Date("2022-06-22T08:30:00"),
        EndDate: new Date("2022-06-25T00:00:00"),
        Id: "nemid-001",
        Headline: "OBS!",
        Text: "Det kan være problemer med at logge ind med Nemid i øjeblikket, vi henviser i mellemtiden til at logge ind med Mitid eller kunde- og aftalenummer.",
        Cta: 'pricechange-001',
        CtaText: '',
        CtaType: 'event',
        ShowOnlyOnURL: [
            '/login', '/login/nemid'],
        ShowOnlyIfLoggedIn: false,
        Theme: "warning"
    }
    */

    {
        StartDate: new Date("2022-09-05T00:00:00"),
        EndDate: new Date("2022-09-05T06:00:00"),
        Id: "netaccept-001",
        Headline: "OBS!",
        Text: "Det er på nuværende tidspunkt ikke muligt at foretage køb med dankort. Ønsker du at spille med allerede i næste trækning bedes du kontakte vores kundeservice på tlf: 33420900.",
        Cta: 'pricechange-001',
        CtaText: '',
        CtaType: 'event',
        ShowOnlyOnURL: [
            '/betaling/spil-med-nu',
            '/min-side/mine-lodsedler',
            '/min-side',
            '/lodder-til-salg/reservation'
           ],
        ShowOnlyIfLoggedIn: false,
        Theme: "warning"
    }
];
